// extracted by mini-css-extract-plugin
module.exports = {"tip":"Tip_tip__1iprJ","info":"Tip_info__2UV_o","icon":"Tip_icon__3L4_G"};